import { render, staticRenderFns } from "./RexOMatic.vue?vue&type=template&id=d73178de&"
import script from "./RexOMatic.vue?vue&type=script&lang=js&"
export * from "./RexOMatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports